<template>
  <div>
    <Card>
      <div class="filter-container">
        <el-select
          clearable
          style="width: 200px"
          class="filter-item"
          v-model="searchData.shop_id"
          placeholder="店铺名称"
        >
          <el-option :key="shop.id" v-for="shop in shops" :label="shop.name" :value="shop.id" />
        </el-select>
        <!-- <el-input
          clearable
          @keyup.enter.native="searchBtnClick"
          style="width: 200px;"
          class="filter-item"
          placeholder="店铺名称"
          v-model="searchData.shop_name"
        /> -->
        <el-input
          clearable
          @keyup.enter.native="searchBtnClick"
          style="width: 200px;"
          class="filter-item"
          placeholder="用户手机"
          v-model="searchData.mobile"
        />
        <el-input
          clearable
          @keyup.enter.native="searchBtnClick"
          style="width: 200px;"
          class="filter-item"
          placeholder="用户昵称"
          v-model="searchData.username"
        />
        <el-input
          clearable
          @keyup.enter.native="searchBtnClick"
          style="width: 200px;"
          class="filter-item"
          placeholder="会员卡号"
          v-model="searchData.nickname"
        />
        <el-button
          size="medium"
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="searchBtnClick()"
          >搜索</el-button>
      </div>
      <el-alert
        v-if="aggregate_test"
        :title="aggregate_test"
        type="success"
        :closable="false"
      ></el-alert>
      <Table
        style="margin-top: 20px;"
        ref="table"
        border
        :loading="loading"
        :columns="columns"
        :data="customers"
        @on-row-click="onRowClick"
      ></Table>
      <Row>
        <Page
          style="margin-top: 20px;"
          show-total
          :total="meta.total"
          :current="meta.current"
          :page-size="meta.pageSize"
          @on-change="changePage"
        ></Page>
      </Row>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" title="修改会员">
      <Form ref="customer" :model="customer" :label-width="80">
        <Form-item label="会员名" prop="username">
          <Input type="text" v-model="customer.username" />
        </Form-item>
        <Form-item label="会员卡号" prop="nickname">
          <Input type="text" v-model="customer.nickname" />
        </Form-item>
        <Form-item label="手机号码" prop="mobile">
          <Input type="text" v-model="customer.mobile" />
        </Form-item>
      </Form>
    </Modal>
    <Modal
      v-model="modalShowResetPassword"
      @on-ok="handleSubmit"
      title="密码重置"
    >
      <Form ref="customer" :model="customer" :label-width="80">
        <Form-item label="密码" prop="password">
          <Input type="text" v-model="customer.password" />
        </Form-item>
        <Form-item label="密码确认" prop="password_confirm">
          <Input type="text" v-model="customer.password_confirm" />
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="modalShowFunction" title="功能">
      <ButtonGroup size="large">
        <Button type="warning" @click="this.update2">修改信息</Button>
        <Button type="default" @click="this.orders">订单记录</Button>
        <Button vertical type="primary" @click="this.bills">充值记录</Button>
        <Button
          type="warning"
          v-show="this.customer.status === 'stopped'"
          @click="this.start2"
          >启用账号</Button
        >
        <Button
          type="warning"
          v-if="this.customer.score === 0 && this.customer.balance === 0"
          @click="this.destroy2"
          >删除账号</Button
        >
        <Button
          type="error"
          v-if="
            (this.customer.score !== 0 || this.customer.balance !== 0) &&
              this.customer.status === 'valid'
          "
          @click="this.stop2"
          >停用账号</Button
        >
        <Button type="info" @click="this.reset_password">密码重置</Button>
      </ButtonGroup>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { tableAvatar } from '@/libs/table-render'

export default {
  data () {
    return {
      searchData: {
        id: undefined
      },
      modalShowFunction: false,
      modalShow: false,
      modalShowResetPassword: false,
      columns: [
        {
          title: 'ID',
          width: 100,
          key: 'id',
          align: 'center'
        },
        {
          title: '店铺名称',
          key: 'shop_name',
          width: 180,
          align: 'center'
        },
        {
          title: '用户名',
          key: 'username',
          width: 150,
          align: 'center'
        },
        {
          title: '会员卡号',
          key: 'nickname',
          width: 150,
          align: 'center'
        },
        {
          title: '手机号码',
          key: 'mobile',
          width: 160,
          align: 'center'
        },
        {
          title: '余额',
          key: 'balance',
          width: 100,
          align: 'center'
        },
        {
          title: '积分',
          key: 'score',
          width: 100,
          align: 'center'
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.status === 'valid' ? '正常' : '停用中')
          }
        },
        {
          title: '头像',
          key: 'avatar',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return tableAvatar(h, params.row.avatar)
          }
        },
        {
          title: '创建时间',
          key: 'created_at_str',
          width: 180,
          align: 'center'
        },
        {
          title: '性别',
          width: 100,
          key: 'gender',
          align: 'center'
        },
        {
          title: '生日',
          key: 'birthday',
          width: 160,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.resetQuery()
    this.index()
    this.shop_index({ per: 1000 })
  },
  computed: {
    ...mapGetters('customer', ['customers', 'customers_all', 'customer', 'aggregate_test', 'meta', 'loading']),
    ...mapGetters('editor', ['editor']),
    ...mapGetters('shop', ['shops'])
  },
  methods: {
    ...mapActions('customer', [
      'clear',
      'index',
      'index_all',
      'show',
      'create',
      'update',
      'destroy',
      'start',
      'stop'
    ]),
    ...mapActions('shop', { shop_index: 'index' }),
    ...mapMutations('customer', ['changeQuery', 'resetQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    handleSubmit () {
      this.update(this.customer)
      this.modalShow = false
      this.modalShowResetPassword = false
      this.modalShowFunction = false
    },
    searchBtnClick () {
      this.resetQuery()
      this.changeQuery(this.searchData)
      this.index()
    },
    orders () {
      this.$router.push(`/customers/${this.customer.id}/orders`)
    },
    bills () {
      this.$router.push(`/customers/${this.customer.id}/bills`)
    },
    reset_password () {
      this.show(this.customer.id)
      this.modalShowResetPassword = true
    },
    onRowClick (params) {
      // this.modalShowFunction = true
      // this.show(params.id)
    },
    start2 () {
      this.start(this.customer.id)
      this.modalShowFunction = false
    },
    stop2 () {
      this.stop(this.customer.id)
      this.modalShowFunction = false
    },
    destroy2 () {
      this.destroy(this.customer.id)
      this.modalShow = false
      this.modalShowFunction = false
    },
    update2 () {
      this.modalShow = true
    },
    async exportData () {
      await this.index_all({ per: 100 })
      this.$refs.table.exportCsv({
        // quoted: true,
        // separator: ',=',
        // original: false,
        columns: this.columns,
        data: this.customers_all,
        filename: '会员信息'
      })
    }
  }
}
</script>
